module.exports = __webpack_public_path__ + "img/F2F3.332e500a.jpg";